(function () {
  function initEngravingReveal(scope) {
    var root = scope || document;
    var els = root.querySelectorAll('.ng-engraving-exact .ab-reveal');
    if (!els.length) return;

    if (window.Shopify && window.Shopify.designMode) {
      els.forEach(function (el) { el.classList.add('in'); });
      return;
    }

    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('in'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });

    els.forEach(function (el) { io.observe(el); });
  }

  document.addEventListener('DOMContentLoaded', function () { initEngravingReveal(document); });
  document.addEventListener('shopify:section:load', function (event) { initEngravingReveal(event.target); });
})();
